import { HttpClient } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import {
  BaseComponent,
  ClaimDataService,
  ConfigurationSetting,
  DialogComponent,
  OverlayMode,
  ProgressService,
  SearchResult,
  srSpeak,
  ToastType,
} from 'src/app/shared';
import {
  buildRtwSameDayMessage,
  RTW_SAME_DAY_MESSAGE,
} from 'src/app/shared/functions/build-rtw-same-day-message';
import { ClaimInfo } from 'src/app/shared/models/search-result';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { UserActionService } from '../../../shared';
import { UserActions } from '../../../shared/models/user';
import { RestrictionTable } from '../../models/Restrictions';
import {
  RTW_SAME_DAY_ERROR_CODE,
  RTWResponseStatus,
} from '../../models/rtw-response';
import { ActivityService } from '../../services/activity.service';
import { ConfigurationService } from '../../services/configuration.service';
import { emulator } from '../../services/emulator.service';
import { InpageAliasService } from '../../services/inpage-alias.service';
import { LogService } from '../../services/log.service';
import { Session } from '../../services/session.service';
import { TranslationService } from '../../services/translation.service';
import { Aliases } from '../../models/aliases';
import { UserRoleService } from '../../services/user-role.service';
import { RestrictionsComponent } from './restrictions.component';

@Component({
    selector: 'app-return-to-work-page',
    template: `
    <app-section class="tw-w-full">
      <div class="app-pl2 tw-w-full">
        <app-claim-breadcrumb class="tw-w-[90%]"></app-claim-breadcrumb>
      </div>
    
      <app-panel
        [headerLevel]="1"
        title="Report return to work"
        class="tw-w-full app-pb4"
        [showTitle]="true"
        [canExpand]="false"
        >
        <app-loading-panel
          [state]="loading || claimLoading ? 'Loading' : 'Loaded'"
          >
          <ng-template #content>
            @if (isRTW === 'submit') {
              <div
                class="app-pb2 tw-w-full"
                #rtweditdialog
                >
                <form [formGroup]="formGroup">
                  <div id="rtweditpnl">
                    <div class="tw-flex tw-flex-wrap">
                      <div class="tw-w-full md:tw-w-[50%]">
                        <app-claimant-label
                          value
                          [claimant]="claim"
                          [showNameLabel]="true"
                          [disabled]="!userRole.manager || claim.userOwns"
                          [nameClass]="'headingbold'"
                          >
                        </app-claimant-label>
                      </div>
                      <div class="app-pb2 tw-w-full md:tw-w-[50%]">
                        <app-claim-label
                          value
                          [claim]="claim"
                          layout="row"
                          [showNameLabel]="true"
                        [hideWatchList]="
                          !(userRole.manager || userRole.controller)
                        "
                        ></app-claim-label>
                      </div>
                      @if (!isDisplaySuccess) {
                        <div
                          class="tw-w-full tw-flex tw-flex-wrap"
                          >
                          <div class="tw-w-full md:tw-w-[40%]">
                            <app-date-control
                              label="Return to Work Date *"
                              ngDefaultControl
                              [formGroup]="formGroup"
                              formControlName="rtwDate"
                            ></app-date-control>
                            @if(showRtwType){
                              <div class="tw-w-full">
                                <app-container-control
                                  ngDefaultControl
                                  [formGroup]="formGroup"
                                  formControlName="duty"
                                  class="app-pb3 headingbold"
                                  [label]="'RETURN TO WORK TYPE *'"
                                  >
                                  <mat-radio-group
                                    aria-label="Full Duty or restricted duty"
                                    role="radiogroup"
                                    formControlName="duty"
                                    >
                                    <mat-radio-button value="Full Duty"
                                      >{{ 'Full Duty' | translation: translationRequest }}</mat-radio-button
                                      >
                                      <span class="app-pl2"></span>
                                      <mat-radio-button value="Restricted Duty"
                                        >{{ 'Restricted Duty' | translation: translationRequest }}</mat-radio-button
                                        >
                                      </mat-radio-group>
                                      @if (IsValidDuty) {
                                        <mat-error class="errormsg"
                                          ><span class="rtwcustomerror">{{
                                          errorMessage
                                        }}</span></mat-error
                                        >
                                      }
                                    </app-container-control>
                                  </div>
                                }
                                <div class="tw-w-full">
                                  <app-text-area-control
                                    label="Additional Comments"
                                    ngDefaultControl
                                    [formGroup]="formGroup"
                                    formControlName="comments"
                                    [maxLength]="500"
                                    [rows]="3"
                                  ></app-text-area-control>
                                </div>
                              </div>
                              <div class="tw-w-full app-pt4">
                                <app-action-row>
                                  <app-button
                                    type="submit"
                                    right2
                                    autofocus
                                    emphasis="High"
                                    mat-raised-button
                                    (click)="submitreturntowork()"
                                    label="Submit"
                                    >
                                  </app-button>
                                  <app-button
                                    right1
                                    emphasis="Low"
                                    (click)="clearForm()"
                                    label="Clear"
                                    ></app-button
                                    >
                                  </app-action-row>
                                </div>
                              </div>
                            }
                            @if (isDisplaySuccess) {
                              <div>
                                <br />
                                <div role="alert" tabindex="-1" #rtwResultToast>
                                  <app-toast [type]="toastType">
                                    @if (toastAlreadyTranslated) {
                                      {{ afterRtwSuccessMessage }}
                                    } @else {
                                      {{ afterRtwSuccessMessage | translation: translationRequest }}
                                    }
                                  </app-toast>
                                </div>
                                @if (uploadDocEnabled && !isBlocked) {
                                  <app-action-link
                                    imageUrl="./assets/images/upload.png"
                                    title="Upload documents"
                                    helpText=""
                                    [routerLink]=""
                                    [imageWidth]="60"
                                    [imageHeight]="53"
                                    routerLink="/upload-documents-in-documentstab"
                        [queryParams]="{
                          focus: 'documents',
                          claimId: claim.claimId,
                          source: claim.source,
                          showDialog: true
                        }"
                                  ></app-action-link>
                                }
                                <ng-template #uploadTemplate>
                                  <app-dialog
                                    title="Upload documents"
                                    ariaLabel="Upload documents dialog"
                                    confirmLabel="Upload"
                                    cancelLabel="Close"
                                    [showActions]="true"
                                    [showConfirm]="false"
                                    [width]="700"
                                    #dialog
                                    >
                                    <app-upload
                                      [dialogRef]="dialog.dialogRef"
                                      [claim]="claim"
                                      [claimId]="claim.claimId"
                                      [source]="claim.source"
                                      [translationRequest]="translationRequest"
                                    ></app-upload>
                                  </app-dialog>
                                </ng-template>
                              </div>
                            }
                          </div>
                        </div>
                      </form>
                    </div>
                  }
                </ng-template>
              </app-loading-panel>
            </app-panel>
          </app-section>
    `,
    styles: [
        `
      .mat-mdc-radio-button:focus {
        border: 1px solid #007dbc;
      }
      .errormsg {
        color: #c24533;
      }
      @media (max-device-width: 480px) {
        ::ng-deep .mat-mdc-text-field-wrapper {
          /* width : 250%;*/
        }
      }

      .btn-info:hover {
        background-color: #035e81;
      }
      .btn-info {
        font-size: 15px;
        color: #ffffff;
        line-height: 30px;
        border-radius: 40px;
        background: #244578;
        background-color: #007dbc;
        font-weight: bold;
      }

      .btn-info-disable {
        font-size: 15px;
        color: gray;
        line-height: 30px;
        border-radius: 40px;
        background-color: lightgray;
        font-weight: bold;
      }

      .rtwcustomerror {
        font-size: 12px;
        font-weight: 500;
        padding-left: 5%;
      }
    `,
    ],
    standalone: false
})
export class ReturnToWorkPageComponent extends BaseComponent implements OnInit {
  claimId: string = '';
  claimConfig: ConfigurationSetting;
  claimInfo$ = new BehaviorSubject<ClaimInfo>(null);
  dialogData: any;

  @Input()
  showDidNotReturn: boolean = true;

  claim: any;
  isManagerRole: boolean = false;
  restrictionTable: RestrictionTable[];
  isDisplaySuccess: boolean = false;
  afterRtwSuccessMessage: string;
  toastType: ToastType = 'Success';
  toastAlreadyTranslated: boolean = false;
  isBlocked: boolean = false;
  allowFileUpload: boolean = false;
  btnDisabled: boolean = true;
  showCRTWDate: boolean = false;
  isHideButtons: boolean = false;
  examinerLabel: Aliases;
  isRTW: string = null;
  rtwTypeFromNotif: string = '';
  rtwDateFromNotif: string = '';
  mgrAction: UserActions | null;
  loading: boolean = true;
  claimLoading: boolean = true;
  alertMasterId: string;
  showRtwType: boolean = true;
  uploadDocEnabled: boolean = false;

  @Input()
  LOB: string;

  @Input()
  hideHeader: boolean = false;

  @Input()
  claimsHistory: any;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Returntowork',
    subGroup: 'Returntowork',
  });

  isController: boolean = false;

  @Output()
  AfterSuccess: EventEmitter<RTWResponseStatus> =
    new EventEmitter<RTWResponseStatus>();

  get Duty() {
    return this.formGroup.get('duty');
  }

  get errorMessage(): string {
    const errorPart = this.translationService.getTranslationForKey('Error', this.translationRequest);
    const messagePart = this.translationService.getTranslationForKey('Return to work type is required', this.translationRequest);
    return `${errorPart} : ${messagePart}.`;
  }

  IsValidDuty: boolean = false;
  formGroup: FormGroup = this.fb.group({
    comments: [],
    noReturn: [],
  });

  @ViewChild('restrictionChild') restrictionChild: RestrictionsComponent;
  @ViewChild('rtweditdialog') rtwdialoag: DialogComponent;
  @ViewChild('rtwResultToast') rtwResultToast: ElementRef<HTMLDivElement>;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    public session: Session,
    private activityService: ActivityService,
    public claimDataService: ClaimDataService,
    public inpageAliasService: InpageAliasService,
    private configurationService: ConfigurationService,
    public overlayService: ProgressService,
    private enumalatorService: emulator,
    public logService: LogService,
    public userRole: UserRoleService,
    public dialog: MatDialog,
    private userActions: UserActionService,
    private translationService: TranslationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.dialogData = data != null ? data : null;
    this.allowFileUpload = this.dialogData.uploadFile;
  }

  loadTranslations(): void {
    this.translationService.getTranslation(this.translationRequest);
  }

  createManagementNotificationForm() {
    this.formGroup.addControl('rtwDate', new FormControl(''));
    this.formGroup.addControl('duty', new FormControl(''));

    this.subs.sink = this.formGroup.controls['duty'].valueChanges.subscribe(
      (value) => {
        if (value) {
          this.IsValidDuty = false;
          this.formGroup.controls['duty'].setErrors(null);
        }
      }
    );
  }

  async ngOnInit() {
    this.loadTranslations();
    this.isManagerRole = this.userRole.supervisor;
    this.isController = this.userRole.controller;
    if (this.isManagerRole) {
      this.mgrAction = this.userActions.getAction();
    }
    this.createManagementNotificationForm();
    if (this.configurationService.GetConfig.configFeatures) {
      this.examinerLabel = await this.inpageAliasService.replaceAliases(
        'examinerSingular',
        this.configurationService.GetConfig.configFeatures.aliases
      );
    }
    this.subs.sink = this.route.queryParams.subscribe((p) =>
      this.loadClaimFromUrl()
    );
  }

  private async loadClaimFromUrl() {
    this.isRTW = this.route.snapshot.queryParamMap.get('rtw');
    this.rtwTypeFromNotif =
      this.route.snapshot.queryParamMap.get('rtwType') ?? '';
    this.alertMasterId =
      this.route.snapshot.queryParamMap.get('alertMasterUid');
    const claimId = this.route.snapshot.queryParamMap.get('claimId');
    const source = this.route.snapshot.queryParamMap.get('source');
    if (claimId) {
      const claim = await lastValueFrom(
        this.http.get<SearchResult>(
          `/api/claim/${source}/${claimId}/${'NA'}/summary`
        )
      );
      this.setClaim(claim);
      this.claimLoading = false;
    }
    const rtwDateFromUrl = this.route.snapshot.queryParamMap.get('rtwDate');
    if (rtwDateFromUrl != null && rtwDateFromUrl != undefined) {
      const valueReplace = rtwDateFromUrl.replaceAll('%2F', '/');
      this.rtwDateFromNotif = valueReplace;
    }
  }

  private async setClaim(claim: SearchResult) {
    if (claim === null) {
      return;
    }
    this.claimId = claim.claimId;
    this.claimInfo$.next(claim);
    this.claim = claim;
    // this.showRtwType = this.claim?.lob !== 'LV';
    this.claimConfig = await this.configurationService.getClaimConfiguration(
      claim
    );
    this.loading = false;
  }

  toggleMethod(val1: number) {
    if (val1 == 1) {
      this.showCRTWDate = false;
      this.btnDisabled = false;
      this.formGroup.get('rtwDate').clearValidators();
      this.formGroup.get('rtwDate').updateValueAndValidity();
    }
    if (val1 == 2) {
      this.showCRTWDate = true;
      this.btnDisabled = false;
    }
  }

  async submitreturntowork() {
    this.uploadDocEnabled =
      this.claimConfig.features.indexOf('uploaddocuments') > -1;
    this.afterRtwSuccessMessage = '';
    if (
      this.formGroup.get('rtwDate').value == '' ||
      this.formGroup.get('rtwDate').value == undefined
    ) {
      this.formGroup
        .get('rtwDate')
        .setErrors({ 'Error : Return to Work Date is required.': true });
      this.formGroup.get('rtwDate').markAsTouched();
    }
    if (
      this.showRtwType &&
      (this.formGroup.get('duty').value == '' ||
        this.formGroup.get('duty').value == undefined)
    ) {
      this.formGroup
        .get('duty')
        .setErrors({ 'Error : Return to Work Type is required.': true });
      this.IsValidDuty = true;
    }
    if (this.formGroup.valid) {
      this.enumalatorService.showAuditorInfo();
      this.overlayService.show(OverlayMode.Spinner, 'Please wait..');
      const rtwData: any = {
        RtwDate:
          this.isRTW === 'confirm'
            ? this.rtwDateFromNotif
            : this.formGroup.get('rtwDate')?.value !== null
            ? new Date(this.formGroup.get('rtwDate').value)
            : null,
        RtwType:
          this.isRTW === 'confirm'
            ? this.rtwTypeFromNotif
            : this.formGroup.get('duty').value,
        Message: this.formGroup.get('comments').value ?? '',
        EmpUnum: this.claim.empUnum,
        LineOfBusiness: this.claim.lob,
        UniqueId: this.claim.claimId,
        ClaimNumber: this.claim.claimNumber,
        ClientNumber: this.claim.client,
        UserClaim: this.claim.userOwns,
        ExaminerName: this.claim.examinerName,
        ExaminerEmail:
          this.claim.examinerEmail != undefined ? this.claim.examinerEmail : '',
        LossDate: this.claim.lossDate,
        Name: this.claim.name,
        Type: this.claim.type,
        Status: this.claim.status,
        SubStatus:
          this.claim.subStatus != undefined ? this.claim.subStatus : '',
        Source: this.claim.source,
      };

      this.http.post<any>('/api/returntowork', rtwData).subscribe(
        (result) => {
          this.overlayService.hide();

          this.formGroup.reset();

          if (result.errorCode === RTW_SAME_DAY_ERROR_CODE) {
            this.showSameDayBlockedMessage(result);
            return;
          }

          const isLiability = this.LOB != 'DS' && this.LOB != 'LV';

          this.isBlocked = false;
          this.toastType = 'Success';
          this.toastAlreadyTranslated = false;
          this.isDisplaySuccess = true;
          if (
            !(
              result.requestValid &&
              result.jurisReqStatus &&
              result.tamsReqStatus
            ) &&
            !isLiability
          ) {
            this.afterRtwSuccessMessage =
              'The return to work date was previously reported. Thank you for ensuring we have your most recent return to work status.';
          } else if (
            (result.requestValid &&
              result.jurisReqStatus &&
              result.tamsReqStatus) ||
            isLiability
          ) {
            this.afterRtwSuccessMessage = this.inpageAliasService.composeSentence([
              this.claim.userOwns ? 'Your' : 'The',
              'return to work date has been submitted.  The',
              { alias: this.examinerLabel },
              'will contact you if they have any further questions.',
            ]);

            if (this.uploadDocEnabled) {
              this.afterRtwSuccessMessage =
                this.afterRtwSuccessMessage +
                '  To provide any supporting documents for the return to work status, click the Upload documents link below.';
            }
          }
          if (this.alertMasterId != null) {
            const alertType = this.getAlertType();
            this.geterateTriggerKeyAndSession(
              alertType,
              this.claim.claimNumber,
              this.claim.source,
              this.alertMasterId
            );

            this.activityService.DismissNotificationAlert(
              alertType,
              this.claim.claimNumber,
              this.claim.claimId,
              this.claim.source,
              this.claim.userOwns,
              this.claim.lob
            );
          }
        },
        (error) => {
          console.log(error);
          this.overlayService.hide();
        }
      );
    }
  }

  // A same calendar day block must not dismiss an outstanding return to work alert
  // or offer the document upload link, because nothing was submitted.
  private showSameDayBlockedMessage(result: RTWResponseStatus) {
    const translatedTemplate = this.translationService.getTranslationForKey(
      RTW_SAME_DAY_MESSAGE,
      this.translationRequest
    );

    this.afterRtwSuccessMessage = buildRtwSameDayMessage(
      translatedTemplate,
      result.submissionTime ?? '',
      result.submissionDate ?? '',
      result.nextEligibleDate ?? ''
    );
    this.toastAlreadyTranslated = true;
    this.toastType = 'Error';
    this.isBlocked = true;
    this.uploadDocEnabled = false;
    this.isDisplaySuccess = true;

    srSpeak(this.afterRtwSuccessMessage, 'assertive');
    setTimeout(() => this.rtwResultToast?.nativeElement.focus());
  }

  clearForm() {
    this.formGroup.reset();
    this.formGroup.get('rtwDate')?.setErrors(null);
    this.formGroup.get('duty')?.setErrors(null);
    this.IsValidDuty = false;
    this.isDisplaySuccess = false;
    this.isBlocked = false;
    this.toastType = 'Success';
    this.toastAlreadyTranslated = false;
    this.afterRtwSuccessMessage = '';
  }

  getAlertType(): string {
    const alertType =
      this.userRole.manager &&
      (this.mgrAction == UserActions.ViewOwnMgrDb ||
        this.mgrAction == UserActions.MgrViewEmpDb)
        ? 'RTW_CONFIRMATION_RM'
        : 'RTW_CONFIRM_NEEDED_A'; // not to overdo the queryparms length

    return alertType;
  }

  geterateTriggerKeyAndSession(
    alertType: string,
    claimNumber: string,
    source: string,
    alertMasterId: string
  ) {
    const triggerKey = `${alertType}_${claimNumber}_${source}`;
    sessionStorage.setItem('triggerKey', triggerKey);
    sessionStorage.setItem('alertMasterId', alertMasterId);
  }

  async updatereturntoworkDate() {
    this.afterRtwSuccessMessage = '';
    if (this.showCRTWDate == true) {
      if (
        this.formGroup.get('rtwDate').value == '' ||
        this.formGroup.get('rtwDate').value == undefined
      ) {
        if (this.isManagerRole) {
          this.formGroup.get('rtwDate').setErrors({
            'Error : New Return to work date is required.': true,
          });
        } else if (!this.isManagerRole) {
          this.formGroup.get('rtwDate').setErrors({
            'Error : Change my return to work date to is required.': true,
          });
        }
        this.formGroup.get('rtwDate').markAsTouched();
      }
    }

    if (this.formGroup.valid) {
      this.enumalatorService.showAuditorInfo();
      this.overlayService.show(OverlayMode.Spinner, 'Please wait..');

      const request = {
        ClaimUid: this.claim.claimId,
        UniqueId:
          this.claim.lob == 'LV' ? this.claim.claimNumber : this.claim.claimId,
        FileNumber: this.claim.claimNumber,
        LineOfBusiness: this.claim.lob,
        examinerName: this.claim.examinerId,
        NewRtwDate: this.showCRTWDate
          ? this.formGroup.get('rtwDate').value != undefined
            ? new Date(this.formGroup.get('rtwDate').value).toLocaleDateString()
            : new Date(
                this.claim.anticipatedReturnToWorkDate
              ).toLocaleDateString()
          : new Date(this.rtwDateFromNotif).toLocaleDateString(),
        RtwType: this.rtwTypeFromNotif
          ? this.rtwTypeFromNotif
          : this.formGroup.get('duty').value,
        Message: this.formGroup.get('comments').value ?? '',
        UnknownRtw: false, // setting this to false as we always have a date for RTW unlike 4.0
        EmpUnum: this.claim.empUnum,
        SourceSystem: this.claim.source,
        AlertMasterUid: this.alertMasterId,
      };

      this.http.post<any>('/api/returntowork/NewRTWDate', request).subscribe(
        (result) => {
          this.overlayService.hide();
          this.isDisplaySuccess = true;
          const CRTWRBval = this.formGroup.get('duty').value;
          if (result.jurisReqStatus) {
            if (CRTWRBval == 'Yes') {
              this.afterRtwSuccessMessage =
                'Thank you.  Your Return to Work Date has been successfully confirmed.';
            } else {
              this.afterRtwSuccessMessage =
                'Thank you.  Your Return to Work Date has been successfully updated.';
            }
            this.isHideButtons = true;
            const alertType = this.getAlertType();

            this.geterateTriggerKeyAndSession(
              alertType,
              this.claim.claimNumber,
              this.claim.source,
              this.alertMasterId
            );

            this.activityService.DismissNotificationAlert(
              alertType,
              this.claim.claimNumber,
              this.claim.claimId,
              this.claim.source,
              this.claim.userOwns,
              'Rtw'
            );
          }
        },
        (error) => {
          console.log(error);
          this.overlayService.hide();
        }
      );
    }
  }
}
